module.exports = __webpack_public_path__ + "img/teacher.3b509ba7.svg";